import { PURPLE, MINT, hexToRgba } from "../utils/designUtils";

/**
 * 등급(학력 기준 / 기술 기준) 뱃지 — 백엔드(GradeUtils)가 계산해 저장한 값을 그대로 표시만 한다.
 * 과거에는 화면마다 등급을 직접 계산하는 함수가 각각 구현되어 있었으나(불일치 위험),
 * 이제는 계산은 서버에서만 하고 프론트는 이 컴포넌트로 표시만 담당한다.
 */
const GradeBadge = ({ grade }) => {
  const gs = {
    '특급': { bg: hexToRgba(PURPLE, .14), color: PURPLE },
    '고급': { bg: hexToRgba(MINT, .14), color: MINT },
    '중급': { bg: '#fff4dc', color: '#c89427' },
    '초급': { bg: '#ececf2', color: '#5d5b6e' },
  }[grade] || { bg: '#ececf2', color: '#5d5b6e' };

  return (
    <span style={{ display: 'inline-block', padding: '2px 10px', borderRadius: 6, background: gs.bg, color: gs.color, fontWeight: 600, fontSize: 12, whiteSpace: 'nowrap' }}>
      {grade || '-'}
    </span>
  );
};

export default GradeBadge;
